import script from "./questionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./questionPage.vue?vue&type=script&setup=true&lang=js"

import "./questionPage.vue?vue&type=style&index=0&id=76dcbd55&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76dcbd55"]])

export default __exports__